/* src/app/views/legal-text-contract/legal-text-contract-bra-bas1/legal-text-contract-bra-bas1.component.scss */
.contract-wrapper {
  background: #ffffff;
  border: 1px solid #d8e0eb;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(16, 43, 78, 0.08);
  overflow: hidden;
  padding: 0;
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
}
.page-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  font-family: var(--app-font-family, "Ford Antenna", sans-serif);
}
.image-position {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.text-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 20px;
  margin-left: 0;
  width: min(1120px, 100%);
}
.styling-the-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
  color: #102b4e;
}
.styling-the-hr {
  height: 2px;
  background-color: #102b4e;
  margin-bottom: 20px;
  width: 100%;
}
.top-element {
  position: relative;
  margin: 14px auto;
  width: 100%;
  max-width: 1120px;
  padding-top: 42px;
}
.header {
  width: min(320px, 100%);
  height: auto;
  background-color: #102b4e;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  min-height: 52px;
}
.header .header-title {
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0.3px;
  padding: 9px 0;
  background: transparent;
  margin: 0;
  line-height: 1.2;
}
.info-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  z-index: 2;
  background-color: #d9e2f3;
  padding: 16px 22px;
  color: #102b4e;
  font-size: 14px;
  line-height: 1.42;
  margin-bottom: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-height: 96px;
  height: auto;
}
.top-box {
  min-height: 126px;
}
.top-box-second {
  min-height: 102px;
}
.top-box-third {
  min-height: 92px;
}
.top-box-fourth {
  min-height: 96px;
}
.first-line-position {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 8px 24px;
  width: 100%;
}
.first-line {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
}
.first-line h5,
.first-line p {
  margin: 0;
  font-size: 14px;
  line-height: 1.42;
  color: #102b4e;
}
.first-line h5 {
  font-weight: 700;
}
.icon-style {
  font-size: 56px;
  color: #000000;
  margin-right: 18px;
  margin-left: 6px;
}
.top-box-third .first-line-position {
  display: grid;
  grid-template-columns: auto minmax(260px, 1fr);
  column-gap: 24px;
}
.top-box-fourth .first-line-position {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: 24px;
}
.bold-words {
  font-weight: bold;
}
.contract-legal-block {
  width: 100%;
  max-width: 1120px;
  box-sizing: border-box;
}
.light-blue-box-text-bold {
  font-weight: bolder;
}
.custom-list-text {
  list-style: none;
  padding: 0;
  margin: 16px 0 0;
  width: 100%;
}
.custom-list-text .li-text {
  text-align: justify;
  font-size: 10pt;
  color: #102b4e;
  margin: 5px 0;
  padding: 5px 0;
  line-height: 1.6;
}
.text-atenttion {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
}
.custom-list-alphabet {
  list-style: none;
  padding-top: 10px;
  padding-left: 2.5em;
}
.custom-list-alphabet .li-alphabet {
  position: relative;
  padding-top: 10px;
  text-align: justify;
  font-size: 10pt;
  color: #102b4e;
  counter-increment: custom-counter;
}
.custom-list-alphabet .li-alphabet:before {
  position: absolute;
  content: "(" counter(custom-counter, lower-alpha) ") ";
  margin-right: 5px;
  left: -2.5em;
}
.a-edit-blue {
  color: #0062af;
  text-decoration-line: none;
}
.a-edit-blue:hover {
  color: #008de2;
}
.custom-text-data {
  position: relative;
  padding-top: 30px;
  font-size: 10pt;
  text-align: center;
}
@media (max-width: 768px) {
  .top-element {
    padding-top: 30px;
  }
  .header {
    width: min(236px, 100%);
    min-height: 42px;
  }
  .header .header-title {
    font-size: 13px;
    padding: 7px 0;
  }
  .info-box {
    padding: 12px 14px;
  }
  .first-line-position {
    flex-wrap: wrap;
    gap: 8px 12px;
  }
  .icon-style {
    font-size: 42px;
    margin-right: 12px;
    margin-left: 2px;
  }
  .top-box-third .first-line-position,
  .top-box-fourth .first-line-position {
    display: flex;
    grid-template-columns: none;
    column-gap: 0;
  }
}
/*# sourceMappingURL=legal-text-contract-bra-bas1.component-DRODFM53.css.map */
